import * as _ from 'underscore';
const Backbone = require('backbone');
import * as $ from 'jquery';

import { config } from './config';

import { AppActions } from './actions/AppActions';
import { IGlob } from '../../../pdc-platform/src/ts/Glob';
import { apiCall } from '../../../_common/platform/ts/AqlUtility';
import { IActiveWidgets, IURLQuery } from './Interfaces';
import { ATTRIBUTE_TYPES } from '../../../_common/platform/ts/ConfigurationConstants';
import { decodeParameterForURL, parseURLAttribute } from '../../../_common/platform/tsx/filtering/FilterUtilities';

//const base64url = require('pdc-platform-base64url');

const TITLE_SETTING_FIELD = 'GUI/Title';

// OE: unused.
// function _workspaceChangesBeforeHide(id) {
//     var def = $.Deferred<any>();

//     if (id == null) {
//         def.resolve();

//         return def;
//     }

//     var inst = this.glob.WorkspaceStore._state.instances[id];

//     var dataStr = serializeWorkspace(inst.data);

//     if ((inst.originalData != null) &&
//         (dataStr !== inst.originalData)) {

//         this.AppActions.createDialog(
//             config.UNSAVED_WORKSPACE_CHANGES_TITLE,

//             config.UNSAVED_WORKSPACE_CHANGES_MESSAGE,

//             () => {
//                 this.glob.AppActions.workspaceSave(
//                     id,
//                     dataStr
//                 );

//                 def.resolve();
//             },

//             () => {
//                 def.resolve();
//             },

//             () => {
//                 def.reject();
//             },

//             'confirm',

//             {
//                 confirmTitle: 'Save changes',
//                 cancelTitle: 'Ignore changes'
//             }
//         );

//     } else {
//         def.resolve();
//     }

//     return def;
// }

class MainRouter extends Backbone.Router {
    routes() {
        return {
            '': 'root',
            'workspace-explorer': 'workspaceExplorer',
            'templates-explorer': 'templatesExplorer',
            'workspaces/new': 'workspaceNew',
            'workspaces/edit/:id': 'workspaceEdit',
            'workspaces/activate/:id': 'workspaceActivate',
            'workspaces/activate/:id/?*queryString': 'workspaceActivateWithQuery',
            'workspaces/:id': 'workspace',
            'workspaces/:id/?*queryString': 'workspace',
            'workspaces/:id/data/:data': 'workspaceData',

            'workspaces/:id/data/:data/?*queryString': 'workspaceData',

            'workspaces/:id/widgets/:widgetId': 'workspaceWidget',
            'workspaces/:id/widgets/:widgetId/?*queryString': 'workspaceWidgetQuery',
            'workspaces/:id/widgets/:widgetId/state/:stateId': 'workspaceWidgetState',
            'workspaces/:id/widgets/:widgetId/data/:data': 'workspaceWidgetData',
            'workspaces/:id/widgets/:widgetId/data/:data/?*queryString': 'workspaceWidgetDataQuery',
            'workspaces/:id/widgets/:widgetId/state/:stateId/data/:data': 'workspaceWidgetDataState',

            'tabs/:tab/workspaces/:id': 'workspaceTab',
            'tabs/:tab/workspaces/:id/?*queryString': 'workspaceTab_QueryWithoutTitle',
            'tabs/:tab/workspaces/:id/title/:title': 'workspaceTab',
            'tabs/:tab/workspaces/:id/title/:title/?*queryString': 'workspaceTab',
            'tabs/:tab/workspaces/:id/data/:data': 'workspaceTabData',
            'tabs/:tab/workspaces/:id/data/:data/?*queryString': 'workspaceTabData',
            'tabs/:tab/workspaces/:id/title/:title/data/:data/?*queryString': 'workspaceTabDataTitle',

            'tabs/:tab/workspaces/:id/state/:stateId': 'workspaceTabStateData',
            'tabs/:tab/workspaces/:id/widgets/:widgetId': 'workspaceTabWidget',
            'tabs/:tab': 'workspaceTab',
            'dir/:dirId/templates/new': 'templateNew',
            'templates/edit/:id': 'templateEdit',
            //settings: 'settings',
            'component/:moduleName': 'component',
            'component/:moduleName/:componentProps': 'component',
            'component/:moduleName/:componentProps/:title': 'component',
            '*default': 'root'
        };
    }

    execute(callback, args, name) {
        const urlString = window.location.search;

        if (urlString != null && urlString.length > 0) {
            debugger;
            const query = this.parseQuery(urlString, false);
            const ws = query['ws'];

            if (ws != null && ws.val != null) {
                const search = decodeURIComponent(urlString).replace('ws=' + ws.val, '');
                const redirect =
                    window.location.origin +
                    window.location.pathname +
                    '#' +
                    ws.val +
                    (search !== '' && search !== '?' ? '/' + search : '');

                window.location.replace(redirect);
            }
        } else {
            if (callback) {
                callback.apply(this, args);
            }
        }
    }

    public _beforeHide = {};

    public _hideActions = {
        workspace: (tab?, id?) => {
            this.AppActions.workspaceHide(id);
        },

        templateEdit: (tab?, id?) => {
            this.AppActions.templateHide(id);
        },

        workspaceView: (tab?, id?) => {
            this.AppActions.workspaceViewHide(id);
        },

        workspaceViewWidget: (id?, widgetId?, stateId?) => {},

        workspaceActivate: (id?) => {
            this.AppActions.workspaceViewHide(id);
        },

        workspaceActivateWithQuery: (id?) => {
            this.AppActions.workspaceViewHide(id);
        },

        workspaceViewTab: () => {},

        workspaceViewTabDrillDowm: () => {},

        workspaceExplorer: () => {
            this.AppActions.workspacesExplorerHide();
        },

        templatesExplorer: () => {
            this.AppActions.templatesExplorerHide();
        }

        // settings: () => {
        //     this.AppActions.userSettingsHide();
        // }
    };

    private isGuid(guid: string): boolean {
        const REGEX_GUID =
            /^(\{){0,1}[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}(\}){0,1}$/gi;

        return REGEX_GUID.test(guid);
    }

    private getWSID(id: string | number): JQueryDeferred<number> {
        const def = $.Deferred();

        if (typeof id === 'string' && this.isGuid(id)) {
            apiCall(this.AppActions, 'workspace_LookupByGuid', {
                guid: id
            }).done((result: any) => {
                const wsid = result.result.wsid;
                def.resolve(wsid);
            });
        } else {
            def.resolve(id);
        }

        return def;
    }

    public _showActions = {
        workspace: (id) => {
            this.AppActions.workspaceShow(id);
            this._setTitle('Edit for Workspace #' + id);
        },

        templateEdit: (id) => {
            this.AppActions.templateShow(id);
            this._setTitle('');
        },

        workspaceView: (id: number | string, options, query) => {
            let distractFree = false;
            let opts = null;
            let activeWidgets: IActiveWidgets = null;

            if (options != null) {
                opts = JSON.parse(atob(decodeURIComponent(options)));
                distractFree = opts.distractFree;
                activeWidgets = opts.activeWidgets;
            }

            this.getWSID(id).done((wsid) => {
                this.AppActions.workspaceViewShow(wsid, null, distractFree && query == null, activeWidgets);
                this.glob.WorkspaceActions.workspaceViewOpen(wsid, 0, null, opts, query);
                this._setTitle('');
            });
        },

        workspaceActivate: (id: number | string) => {
            this.getWSID(id).done((wsid) => {
                this.AppActions.workspaceViewShow(wsid);
                this.glob.WorkspaceActions.workspaceViewOpen(wsid);
                this._setTitle('');
            });
        },

        workspaceActivateWithQuery: (id: number | string, query) => {
            this.getWSID(id).done((wsid) => {
                this.AppActions.workspaceViewShow(wsid);
                this.glob.WorkspaceActions.workspaceViewOpen(wsid, undefined, undefined, undefined, query);
                this._setTitle('');
            });
        },

        workspaceViewWidget: (id: number | string, widgetId: number, stateId, query) => {
            this.getWSID(id).done((wsid) => {
                this.AppActions.workspaceViewShow(wsid, stateId, true);
                this.AppActions.workspaceWidgetViewOpen(wsid, widgetId, stateId, {}, query);
                this._setTitle('');
            });
        },

        workspaceViewWidgetData: (id: number | string, widgetId: number, stateId, dataURI, query) => {
            this.getWSID(id).done((wsid) => {
                const widgetState = JSON.parse(atob(decodeURIComponent(dataURI)));

                this.AppActions.workspaceViewShow(wsid);
                this.AppActions.workspaceWidgetViewOpen(wsid, widgetId, stateId, widgetState, query);
                this._setTitle('');
            });
        },

        workspaceViewTabWidget: (tabIndex: number, id: number | string, widgetId: number) => {
            this.getWSID(id).done((wsid) => {
                this.AppActions.workspaceViewShow(wsid);
                this.glob.WorkspaceActions.workspaceViewOpen(wsid, tabIndex, widgetId);
                this._setTitle('');
            });
        },

        workspaceViewTab: (tabIndex: number, id: number | string, options, query: IURLQuery, tabTitle: string) => {
            let distractFree = false;
            let opts = null;
            let activeWidgets: IActiveWidgets = null;

            if (options != null) {
                const optsstr = atob(decodeURIComponent(options));

                opts = JSON.parse(optsstr);
                distractFree = opts.distractFree;
                activeWidgets = opts.activeWidgets;
            }

            this.getWSID(id).done((wsid) => {
                this.AppActions.workspaceViewShow(wsid, null, distractFree && query == null, activeWidgets);

                if (opts != null && opts.drilldown != null && opts.drilldown.query == null) {
                    opts.drilldown.query = query;
                    query = null;
                }

                const tab =
                    tabTitle != null
                        ? {
                              tabIndex: tabIndex,
                              tabTitle: tabTitle
                          }
                        : tabIndex;

                this.glob.WorkspaceActions.workspaceViewOpen(wsid, tab, null, opts, query);

                let title = 'Tab #' + tabIndex;
                let isPrefix: boolean = false;

                if (id != null) {
                    const inst_state = this.glob.WorkspaceStore.getInstanceState(wsid);

                    if (inst_state != null) {
                        if (inst_state.loading) {
                            inst_state._defs.initialLoad.then((result) => {
                                this._setTitle(result.result.name, true);
                            });
                        } else if (inst_state.name != null) {
                            title = inst_state.name;
                            isPrefix = true;
                        } else {
                            title += ' Workspace #' + wsid;
                        }
                    }
                }

                this._setTitle(title, isPrefix);
            });
        },

        workspaceViewTabStateData: (tabIndex: number, id: number | string, stateId) => {
            this.getWSID(id).done((wsid) => {
                this.AppActions.workspaceViewShow(wsid, stateId, true);
                this.glob.WorkspaceActions.workspaceViewOpen(wsid, tabIndex);

                var title = 'Tab #' + tabIndex;
                var isPrefix: boolean = false;

                if (id != null) {
                    const inst_state = this.glob.WorkspaceStore.getInstanceState(wsid);

                    if (inst_state != null) {
                        if (inst_state.loading) {
                            inst_state._defs.initialLoad.then((result) => {
                                this._setTitle(result.result.name, true);
                            });
                        } else if (inst_state.name != null) {
                            title = inst_state.name;
                            isPrefix = true;
                        } else {
                            title += ' Workspace #' + id;
                        }
                    }
                }

                this._setTitle(title, isPrefix);
            });
        },

        workspaceExplorer: () => {
            this.AppActions.workspacesExplorerShow();
            this._setTitle('');
        },

        templatesExplorer: () => {
            this.AppActions.templatesExplorerShow();
            this._setTitle('');
        },

        logout: () => {
            this.AppActions.signOut();
            this.navigate('/', { replace: true, trigger: false });
            this._setTitle('');
        },

        // settings: () => {
        //     this.AppActions.userSettingsShow();
        // },

        component: (moduleName: string, componentProps, title: string) => {
            if (moduleName == null) {
                return this.AppActions.mainViewShow();
            }

            Backbone.history.stop();
            this.AppActions.componentShow(moduleName, componentProps);
            this._setTitle(title);
        },

        workspaceApp: (id) => {
            this.AppActions.workspaceViewShow(id, null, true);
            this.glob.WorkspaceActions.workspaceViewOpen(id);
        },

        workspaceAppTab: (tab, id) => {
            this.AppActions.workspaceViewShow(id, null, true);
            this.glob.WorkspaceActions.workspaceViewOpen(id, tab);
        },

        root: () => {
            this.AppActions.mainViewShow();
        }
    };

    _show(name: string, ...args) {
        const url = Backbone.history.root + Backbone.history.fragment;

        this.nextRoute = {
            url: url,
            routeName: name,
            args: args
        };

        if (this.currentRoute != null && typeof this._beforeHide[this.currentRoute.routeName] === 'function') {
            const func = this._beforeHide[this.currentRoute.routeName];
            const def = func.apply(this, this.currentRoute.args);

            let waitFor = false;

            if (def.state() !== 'resolved') {
                waitFor = true;
            }

            $.when(def)
                .done(() => {
                    this._showReady(name, args);
                })
                .fail(() => {
                    if (waitFor) {
                        this.navigate(this.currentRoute.url, { trigger: false, replace: false });
                    }
                });
        } else {
            this._showReady(name, args);
        }
    }

    _showReady(name: string, args: any[]) {
        this.currentRoute = this.nextRoute;
        this.prevRoute = this.currentRoute;

        this._processShow(name, args);
    }

    _processShow(name: string, args: any[]) {
        _.each(this._hideActions, (action, actionName) => {
            if (actionName === name) {
                return;
            }

            action(...args);
        });

        if (typeof this._showActions[name] !== 'function') {
            return;
        }

        this._showActions[name](...args);
    }

    _setTitle(str: string, prefix?: boolean) {
        const {
            app: { settings }
        } = this.glob.SettingsStore.getState();

        let title = settings[TITLE_SETTING_FIELD] || config.TITLE_PREFIX;

        if (config.LAYOUT_TYPE !== 'narrow') {
            if (prefix) {
                if (str.length > 0) {
                    title = str + ' - ' + title;
                }
            } else {
                if (str.length > 0) {
                    title += ' - ' + str;
                }
            }
            document.title = title;
        }
    }

    root() {
        this._show('root');
    }

    templatesExplorer() {
        this._show('templatesExplorer');
    }

    workspaceExplorer() {
        this._show('workspaceExplorer');
    }

    workspaceEdit(id) {
        if (typeof id !== 'number' && !this.isGuid(id)) {
            id = parseInt(id, 10);
        }

        this._show('workspace', id);
    }

    workspaceActivate(id) {
        if (typeof id !== 'number' && !this.isGuid(id)) {
            id = parseInt(id, 10);
        }

        this._show('workspaceActivate', id);
    }

    workspaceActivateWithQuery(id, queryString) {
        if (typeof id !== 'number' && !this.isGuid(id)) {
            id = parseInt(id, 10);
        }

        let query: IURLQuery = null;

        if (queryString) {
            query = this.parseQuery(queryString);
        }

        this._show('workspaceActivateWithQuery', id, query);
    }

    templateEdit(id) {
        if (typeof id !== 'number' && !this.isGuid(id)) {
            id = parseInt(id, 10);
        }

        this._show('templateEdit', id);
    }

    templateNew(dirId) {
        if (typeof dirId !== 'number') {
            dirId = parseInt(dirId, 10);
        }

        this._show('templateEdit');
        this.AppActions.templateCreateNew(dirId);
    }

    workspace(id, queryString) {
        if (typeof id !== 'number' && !this.isGuid(id)) {
            id = parseInt(id, 10);
        }

        let query: IURLQuery = null;

        if (queryString) {
            query = this.parseQuery(queryString);
        }

        this._show('workspaceView', id, null, query);
    }

    workspaceData(id, options, queryString) {
        if (typeof id !== 'number' && !this.isGuid(id)) {
            id = parseInt(id, 10);
        }

        let query: IURLQuery = null;

        if (queryString) {
            query = this.parseQuery(queryString);
        }

        this._show('workspaceView', id, options, query);
    }

    workspaceWidget(id, widgetId) {
        if (typeof id !== 'number' && !this.isGuid(id)) {
            id = parseInt(id, 10);
        }

        if (typeof widgetId !== 'number') {
            widgetId = parseInt(widgetId, 10);
        }

        this._show('workspaceViewWidget', id, widgetId, null, null);
    }

    workspaceWidgetState(id, widgetId: number | string, stateId) {
        if (typeof id !== 'number' && !this.isGuid(id)) {
            id = parseInt(id, 10);
        }

        //EVG: See Issue 89203. A Widget can be refered by name.
        // if (typeof widgetId !== 'number') {
        //     widgetId = parseInt(widgetId, 10);
        // }

        if (typeof stateId !== 'number' && stateId != null) {
            stateId = parseInt(stateId, 10);
        }

        this._show('workspaceViewWidget', id, widgetId, stateId, null);
    }

    workspaceWidgetQuery(id, widgetId, queryString) {
        if (typeof id !== 'number' && !this.isGuid(id)) {
            id = parseInt(id, 10);
        }

        if (typeof widgetId !== 'number') {
            var parsed = parseInt(widgetId, 10);

            if (!isNaN(parsed)) {
                widgetId = parsed;
            }
        }

        let query: IURLQuery = null;

        if (queryString) {
            query = this.parseQuery(queryString);
        }

        this._show('workspaceViewWidget', id, widgetId, null, query);
    }

    workspaceWidgetData(id, widgetId, data) {
        if (typeof id !== 'number' && !this.isGuid(id)) {
            id = parseInt(id, 10);
        }

        if (typeof widgetId !== 'number') {
            widgetId = parseInt(widgetId, 10);
        }

        this._show('workspaceViewWidgetData', id, widgetId, null, data);
    }

    workspaceWidgetDataState(id, widgetId, stateId, data) {
        if (typeof id !== 'number' && !this.isGuid(id)) {
            id = parseInt(id, 10);
        }

        if (typeof widgetId !== 'number') {
            widgetId = parseInt(widgetId, 10);
        }

        if (typeof stateId !== 'number' && stateId != null) {
            stateId = parseInt(stateId, 10);
        }

        this._show('workspaceViewWidgetData', id, widgetId, stateId, data);
    }

    workspaceWidgetDataQuery(id, widgetId, data, queryString) {
        if (typeof id !== 'number' && !this.isGuid(id)) {
            id = parseInt(id, 10);
        }

        if (typeof widgetId !== 'number') {
            widgetId = parseInt(widgetId, 10);
        }

        let query: IURLQuery = null;

        if (queryString) {
            query = this.parseQuery(queryString);
        }

        this._show('workspaceViewWidgetData', id, widgetId, null, data, query);
    }

    workspaceTabWidget(tabIndex, id, widgetId) {
        if (typeof tabIndex !== 'number' && !this.isGuid(id)) {
            tabIndex = parseInt(tabIndex, 10);
        }

        if (typeof id !== 'number') {
            id = parseInt(id, 10);
        }

        if (typeof widgetId !== 'number') {
            widgetId = parseInt(widgetId, 10);
        }

        this._show('workspaceViewTabWidget', tabIndex, id, widgetId);
    }

    workspaceTab(tabIndex, id, tabTitle, queryString) {
        if (typeof tabIndex !== 'number') {
            tabIndex = parseInt(tabIndex, 10);
        }

        if (id != null && typeof id !== 'number' && !this.isGuid(id)) {
            id = parseInt(id, 10);
        }

        let query: IURLQuery = null;

        if (queryString != null) {
            query = this.parseQuery(queryString);
        }

        this._show('workspaceViewTab', tabIndex, id, null, query, tabTitle);
    }

    workspaceTab_QueryWithoutTitle(tabIndex, id, queryString) {
        this.workspaceTab(tabIndex, id, null, queryString);
    }

    workspaceTabData(tabIndex, id, options, queryString) {
        if (id != null && typeof id !== 'number' && !this.isGuid(id)) {
            id = parseInt(id, 10);
        }

        if (typeof tabIndex !== 'number') {
            tabIndex = parseInt(tabIndex, 10);
        }

        let query: IURLQuery = null;

        if (queryString) {
            query = this.parseQuery(queryString);
        }

        this._show('workspaceViewTab', tabIndex, id, options, query, null);
    }

    workspaceTabDataTitle(tabIndex, id, tabTitle, options, queryString) {
        if (id != null && typeof id !== 'number' && !this.isGuid(id)) {
            id = parseInt(id, 10);
        }

        if (typeof tabIndex !== 'number') {
            tabIndex = parseInt(tabIndex, 10);
        }

        let query: IURLQuery = null;

        if (queryString) {
            query = this.parseQuery(queryString);
        }

        this._show('workspaceViewTab', tabIndex, id, options, query, tabTitle);
    }

    workspaceTabStateData(tabIndex, id, stateId) {
        if (typeof tabIndex !== 'number' && !this.isGuid(id)) {
            tabIndex = parseInt(tabIndex, 10);
        }

        if (typeof id !== 'number') {
            id = parseInt(id, 10);
        }

        if (typeof stateId !== 'number' && stateId != null) {
            stateId = parseInt(stateId, 10);
        }

        this._show('workspaceViewTabStateData', tabIndex, id, stateId);
    }

    workspaceNew() {
        this._show('workspace');
        this.AppActions.workspaceCreateNew();
    }

    logout() {
        this._show('logout');
    }

    // settings() {
    //     this._show('settings');
    // }

    //Be sure that this function and CKEDITOR_CONFIG_STATIC use the same coding format.
    component(moduleName, componentProps, title) {
        try {
            //moduleName = base64url.decode(moduleName, 'utf8');
            moduleName = atob(moduleName);
        } catch (e) {
            moduleName = null;
        }

        try {
            //componentProps = JSON.parse(base64url.decode(componentProps, 'utf8'));
            componentProps = JSON.parse(atob(componentProps));
        } catch (e) {}

        try {
            //title = base64url.decode(title, 'utf8');
            title = atob(title);
        } catch (e) {}

        if (componentProps == null) {
            componentProps = {};
        }

        if (title == null) {
            title = '';
        }

        this._show('component', moduleName, componentProps, title);
    }

    // // simple query parser
    // // only '=' operand is allowed
    // // example: attr1=val1&@var1='abcdf'
    // //----------------------------------
    // parseQuery0(queryString) {
    //     var query = {};
    //     var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');

    //     for (let i = 0; i < pairs.length; i++) {
    //         const pair = pairs[i].split('=');

    //         // unquoting
    //         const value = _.map(decodeURIComponent(pair[1] || '').match(/(".*?"|[^",\s]+)(?=\s*,|\s*$)/g), (arg) => {
    //             return arg.replace(/^\s*"?|"?\s*$/g, '');
    //         });

    //         if (pair[0] !== '' && value.length > 0) {
    //             let key = decodeURIComponent(pair[0]).replace(/^\s*"?|"?\s*$/g, '');

    //             if (key === 'datasource') {
    //                 key = 'datasource_' + i.toString(); // we need uniq datasource keys. it will be processed further during State creation
    //             }

    //             query[key] = value.length == 1 ? value[0].split(',') : value;
    //         }
    //     }
    //     return query;
    // }

    // In addition to '=' operand, the following functions are allowed: eq, ne, lt, gt, le, ge
    // example: eq(attr1.attr2,"12345")&ne(@var1,[1,2,3])&lt("abc.ddd",["tyu","DD","FF"])&"@CY"=2017
    parseQuery(queryString: string, decodeParameters = true): IURLQuery {
        const result: IURLQuery = {};
        // /(eq|ne|lt|gt|le|ge)\(([^,]+),([^)]+)\)/g;
        const regExpFunction = new RegExp(/(eq|ne|lt|gt|le|ge)\(([^,]+),\s*((".*?")|(^"[^)]+))\)/g);
        const regExpOperand = new RegExp(/([^=]+)\=(.+)/g);
        const decodedQueryString = decodeURIComponent(queryString[0] === '?' ? queryString.substr(1) : queryString);
        const args = decodedQueryString.split('&');
        const attrHash: { [attr: string]: number } = {};

        const getKey = (attr: string) => {
            if (attrHash[attr] == null) {
                attrHash[attr] = 0;
                return attr;
            } else {
                attrHash[attr] = attrHash[attr] + 1;
                return attr + '_' + attrHash[attr];
            }
        };

        args.forEach((argument) => {
            // Try op as functor.
            if (argument.match(regExpFunction) != null) {
                let res: RegExpExecArray;

                while ((res = regExpFunction.exec(argument))) {
                    const attr = res[2].replace(/^\s*"?|"?\s*$/g, '');

                    let valueString = res[3].replace(/^\s*"?|"?\s*$/g, '') || '';

                    if (decodeParameters) {
                        valueString = decodeParameterForURL(valueString);
                    }

                    const { attributeType } = parseURLAttribute(attr, { attr: attr, op: res[1], val: [valueString] });

                    //EVG 27.05.2024: See Issue 84631. Remove from date values all from " (" to ")".
                    if (attributeType === ATTRIBUTE_TYPES.DATE || attributeType === ATTRIBUTE_TYPES.DATETIME) {
                        valueString = valueString.replace(/ \(([^)]+)\)/g, '');
                    }

                    const value = _.chain(valueString.match(/(".*?"|[^",]+)(?=\s*,|\s*$)/g))
                        .map((v: any) => {
                            const retVal = v.replace(/^\s*"?|"?\s*$/g, '');

                            if (retVal !== '') {
                                return retVal;
                            } else {
                                return null;
                            }
                        })
                        .without(null)
                        .value();

                    const key = getKey(attr);

                    result[key] = {
                        op: res[1],
                        attr: attr,
                        val: value
                    };
                }
            }
            // try op as operator (only '=' is supported (for comaptibility with previous version))
            else if (argument.match(regExpOperand) != null) {
                let res: RegExpExecArray;

                while ((res = regExpOperand.exec(argument))) {
                    const attr = res[1].replace(/^\s*"?|"?\s*$/g, '');
                    const value = _.chain(
                        (res[2].replace(/^\s*"?|"?\s*$/g, '') || '').match(/(".*?"|[^",]+)(?=\s*,|\s*$)/g)
                    )
                        .map((v) => {
                            const retVal = v.replace(/^\s*"?|"?\s*$/g, '');

                            if (retVal !== '') {
                                return retVal;
                            } else {
                                return null;
                            }
                        })
                        .without(null)
                        .value();

                    const key = getKey(attr);

                    result[key] = {
                        op: 'eq',
                        attr: attr,
                        val: value
                    };
                }
            }
        });

        return result;
    }

    private currentRoute: any;
    private prevRoute: any;
    private nextRoute: any;

    private bindEvent(element, eventName, eventHandler) {
        if (element.addEventListener) {
            element.addEventListener(eventName, eventHandler, false);
        } else if (element.attachEvent) {
            element.attachEvent('on' + eventName, eventHandler);
        }
    }

    constructor(public glob: IGlob, public AppActions: AppActions, extender) {
        super();

        if (typeof extender === 'function') {
            extender(this);
        }

        // this.bindEvent(window, 'message', (e) => {
        //     //EVG: See 89463. In that case exceljs sends a message at start about something is not loaded.
        //     // It made call navigate to root, because e.data === ''.
        //     //
        //     // OE: prevent navigation on #setImmediate$ (React19 issue)
        //     // See implementation of installPostMessageImplementation in setImmetiate package
        //     // Installs an event handler on `global` for the `message` event: see
        //     // * https://developer.mozilla.org/en/DOM/window.postMessage
        //     // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
        //     //var messagePrefix = "setImmediate$" + Math.random() + "$";

        //     if (typeof e.data === 'string' && e.data !== '' && !e.data.toLowerCase().startsWith('setimmediate$')) {
        //         this.navigate(e.data, { replace: true, trigger: true });
        //     }
        // });
    }
}

function getReal(glob: IGlob, AppActions, extender) {
    return new MainRouter(glob, AppActions, extender);
}

export function get(glob: IGlob, AppActions, extender?) {
    const res = getReal(glob, AppActions, extender);

    return res;
}
